import Vue from 'vue'
import alerts from './alerts'
import formatValue from './formatValue'
import global from './global'

Vue.mixin(formatValue);
Vue.mixin(alerts);
Vue.mixin(global);
